import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
import { JsonLd, useSEO } from '../utils/seo';
export function Home() {
  useSEO({
    title: 'Gravel Delivery Seattle, WA | Same-Day Bulk Materials | 206Gravel',
    description: 'Order gravel, crushed rock, topsoil, bark, and drain rock online with dependable same-day and next-day delivery across Seattle, King County, and Pierce County.',
    path: '/'
  });
  return <main data-id="element-2717" data-mp="2dirup0mcp005">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: '206Gravel',
      url: 'https://206gravel.com',
      telephone: '+1-206-619-3742',
      email: 'info@206gravel.com',
      priceRange: '$',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Bonney Lake',
        addressRegion: 'WA',
        addressCountry: 'US'
      },
      areaServed: ['Seattle', 'Tacoma', 'Bellevue', 'King County', 'Pierce County'],
      description: 'Locally owned bulk gravel, rock, soil, bark, and aggregate delivery across King and Pierce counties.'
    }} data-id="element-2718" data-mp="2dii4bbxe8qtx" />
      <div className="dark" data-id="element-2719" data-mp="2mwqrd9v9f64a">
        <Hero data-id="element-2720" data-mp="2hxxdhgc29d3l" />
      </div>
      <WhyUs data-id="element-2721" data-mp="2hy6zkstzj040" />
      <ByTheNumbers data-id="element-2722" data-mp="2hyp7wntx94sa" />
      <Services data-id="element-2723" data-mp="2hz8fpbpuycsl" />
      <FAQ data-id="element-2724" data-mp="2hzqkiwql5zc4" />
      <Reviews data-id="element-2725" data-mp="2d772nnkv8i1i" />
      <CtaBanner data-id="element-2726" data-mp="2d6ozs83p75km" />
    </main>;
}